export const FILTER_COMPONENT_OPTIONS = {
  favorites: [],
  topics: ['categories'],
  subtopics: ['categories', 'topics'],
  musicTopics: [],
  musicSubtopics: ['topics'],
  formats: [],
}
